<mat-expansion-panel hideToggle [expanded]=true *ngIf="showFirmar">
  <mat-expansion-panel-header>
    <mat-panel-title>
      Firmar documentos
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="row-resumen">
    <div class="row-resumen-orden ">
      <div class="txt-firmar-documentos">
        <p>
          <b>Para continuar con esta contratación</b> necesitas que tu y todas las personas autorizadas en la escritura
          o por poder notarial, firmen digitalmente el documento.
        </p>
        <p>Contestando <b>4 preguntas personales</b> que verifican la identidad de cada socio(a).</p>
      </div>
      <div class="col-md-6 p-0">
        <span class="txt-firmar-documentos"> <b>Documentos a firmar:</b></span>
        <br>
        <span class="txt-firmar-documentos">- Carta poder cuenta tercero
          <span class="txt-prvisualizar" *ngIf='showDocumentLetter'
            (click)="preView('carta')">previsualizar</span>
          <span class="txt-firmar-documentos" *ngIf='!showDocumentLetter'><strong>Espere un momento...</strong></span>
        </span>
      </div>
    </div>
  </div>

  <section *ngIf="!cargandoAnexos">
    <div class="spinner-border text-light" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </section>

  <section>
    <!-- Ejecutar la firma digital - PJ -->
    <div class="row-resumen" *ngIf="listSignersView.length > 0">
      <div class="row" *ngFor="let firmante of listSignersView">
        <div class="col-md-8">
          <p class="txt-nombre"> A nombre de: <b>{{ firmante.nombre}}</b>, <b>RUT {{ firmante.rut | formatrut }}, </b>
            Nacionalidad <b>{{ firmante.nacionalidad }}</b></p>
        </div>
        <div class="col-md-4 d-flex justify-content-end">
          <img src="assets/icons/icon-check.svg" alt="checkFirma" *ngIf="firmante.estado === 'APROBADO' ">
          <div *ngIf="firmante.estado === 'SIN_APROBAR' ">
            <button class="btn-secondary-tbk" type="button" (click)='firmarDocumentoRRLL(firmante.rut)' [disabled]="firmarDoc">
              <div class="spinner-border text-light" id="loadingBtnFirm" *ngIf='firmarDoc' role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <span *ngIf="!firmarDoc && firmante.estado === 'SIN_APROBAR'" >
                Firmar
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--Botón para ejecutar la firma digital - PN -->
    <div class="row-resumen" *ngIf="listSignersView.length === 0">
      <div class="row">
        <div class="col-md-8">&nbsp;</div>
        <div class="col-md-4 d-flex justify-content-end">
          <button class="btn-secondary-tbk" type="submit" (click)='firmarDocumento()'>
            <div class="spinner-border text-light" id="loadingBtnFirm" *ngIf='firmarDoc' role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <span *ngIf='!firmarDoc'>
              Firmar
            </span>
          </button>
        </div>
      </div>
    </div>
    
    <app-messages *ngIf="true" class="informativo"
        message="Firmarás(n) digitalmente tu solicitud al sistema de tarjetas operadas por Transbank. El certificado digital emitido en esta instancia, es válido solo para la firma de estos documentos y es dispuesto por Transbank. ">
    </app-messages>
  </section>
</mat-expansion-panel>

<div class="row" *ngIf="showFirmar">
  <div class="col-md-12">
    <button class="btn-primary-tbk" type="button" [disabled]="!isAceptaTerminos" (click)="continuarPaso3()">
      <div *ngIf="loadingButton" class="spinner-border text-light" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div *ngIf="!loadingButton">Continuar</div>
    </button>
  </div>
</div>



<!-- Modal Pantalla Completa -->
<div class="modal fade modal-fullscreen" id="noActividadModal" tabindex="-1" role="dialog" aria-labelledby="noActividadModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <!-- <div class="modal-header">
          <h5 class="modal-title font-weight-bold" id="modalLabel">El RUT no ha iniciado actividades</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Cerrar">
              <span aria-hidden="true">&times;</span>
          </button>
      </div> -->
      <div class="modal-body">
          <div class="info-container">
              <!-- Sección Izquierda - Título y descripción -->
              <div class="container mt-title">
                  <span class="d-flex justify-content-start mb-2">
                    ¡Hola Matilde !</span>
                  <h2 class="text-dark title-modal text-left">Identificamos que aún no tienes<span class="title-modal" style="color: #3B3CF7;"> Inicio de actividades en SII.</span>
                    No te preocupes, te podemos ayudar con esto 🤗</h2>
                   <p class="text-muted">Nuestros ejecutivos te asistirán para seguir creciendo juntos.</p> 
                  <div class="d-flex justify-content-center">
                    
                    <div class="container">
                    <div class="col p-2 bd-highlight">
                      <button class="btn-primary-tbk btn-primary-tbk-modal">
                        <div >Quiero que me ayuden</div>
                      </button>
                    </div>

                    <div class="col p-2 bd-highlight">
                      <a href="#" class="text-decoration-none"><samp><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M8.00065 1.33301C6.68211 1.33301 5.39318 1.724 4.29685 2.45654C3.20052 3.18909 2.34604 4.23028 1.84146 5.44845C1.33687 6.66663 1.20485 8.00707 1.46209 9.30028C1.71932 10.5935 2.35426 11.7814 3.28661 12.7137C4.21896 13.6461 5.40685 14.281 6.70005 14.5382C7.99326 14.7955 9.3337 14.6635 10.5519 14.1589C11.7701 13.6543 12.8112 12.7998 13.5438 11.7035C14.2763 10.6071 14.6673 9.31822 14.6673 7.99967C14.6673 7.1242 14.4949 6.25729 14.1599 5.44845C13.8248 4.63961 13.3338 3.90469 12.7147 3.28563C12.0956 2.66657 11.3607 2.17551 10.5519 1.84048C9.74304 1.50545 8.87613 1.33301 8.00065 1.33301ZM8.00065 11.9997C7.8688 11.9997 7.73991 11.9606 7.63027 11.8873C7.52064 11.8141 7.43519 11.7099 7.38473 11.5881C7.33428 11.4663 7.32107 11.3323 7.3468 11.2029C7.37252 11.0736 7.43602 10.9548 7.52925 10.8616C7.62249 10.7684 7.74127 10.7049 7.87059 10.6792C7.99992 10.6534 8.13396 10.6666 8.25578 10.7171C8.37759 10.7675 8.48171 10.853 8.55497 10.9626C8.62822 11.0723 8.66732 11.2012 8.66732 11.333C8.66732 11.5098 8.59708 11.6794 8.47206 11.8044C8.34703 11.9294 8.17747 11.9997 8.00065 11.9997ZM8.66732 8.55967V9.33301C8.66732 9.50982 8.59708 9.67939 8.47206 9.80441C8.34703 9.92944 8.17747 9.99967 8.00065 9.99967C7.82384 9.99967 7.65427 9.92944 7.52925 9.80441C7.40423 9.67939 7.33399 9.50982 7.33399 9.33301V7.99967C7.33399 7.82286 7.40423 7.65329 7.52925 7.52827C7.65427 7.40325 7.82384 7.33301 8.00065 7.33301C8.19844 7.33301 8.39178 7.27436 8.55622 7.16448C8.72067 7.0546 8.84885 6.89842 8.92453 6.71569C9.00022 6.53297 9.02003 6.3319 8.98144 6.13792C8.94285 5.94394 8.84761 5.76575 8.70776 5.6259C8.56791 5.48605 8.38973 5.39081 8.19574 5.35222C8.00176 5.31364 7.8007 5.33344 7.61797 5.40913C7.43525 5.48482 7.27907 5.61299 7.16918 5.77744C7.0593 5.94189 7.00065 6.13523 7.00065 6.33301C7.00065 6.50982 6.93042 6.67939 6.80539 6.80441C6.68037 6.92944 6.5108 6.99967 6.33399 6.99967C6.15718 6.99967 5.98761 6.92944 5.86258 6.80441C5.73756 6.67939 5.66732 6.50982 5.66732 6.33301C5.66558 5.89988 5.78443 5.47481 6.01056 5.10539C6.2367 4.73598 6.5612 4.43679 6.94773 4.24134C7.33426 4.04589 7.76757 3.96189 8.19913 3.99874C8.6307 4.03558 9.04349 4.19183 9.39129 4.44997C9.73909 4.70812 10.0082 5.05798 10.1684 5.46039C10.3287 5.86279 10.3737 6.30186 10.2986 6.72842C10.2234 7.15499 10.031 7.55222 9.74294 7.87565C9.45484 8.19907 9.0824 8.43592 8.66732 8.55967Z" fill="#007EFF"/>
                        </svg></samp>  ¿En qué consiste iniciar actividades?</a>
                  </div>
                  </div>

                </div>
              </div>
        </div>
    </div>
</div>